export default "__VITE_ASSET__c7h8xXMj__"